import { getDecryptLocalStorage } from '../utils/global_functions'
import { LOCAL_STORAGE_KEYS } from '../utils/global_variables'

const HealthStatus = () => {
	let info = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.SOCKET_HEALTH_INFO)
	let parsedInfo = JSON.parse(info)
    let str = "I am alive and healthy!!!"
	if(parsedInfo){
		for(const [key,value] of Object.entries(parsedInfo)){
	     str = str + ' ' + `[${key}]: ${value},`
	 }
	}



	return (
		<div style={{display: 'flex', justifyContent: "center"}}>
			<div>{str}</div>
		</div>
	)
}

export default HealthStatus